// FriendsPage.tsx
import React, { useEffect, useState } from 'react';
import FriendUnit from './FriendUnit';
import axios from 'axios';
import { useAppContext } from './AppContext';

type Friend = {
  tgID: number
  tgLogin: string
}

type FriendData = {
	invitedByTG: number
  invitedByTGLogin: string | null
	invitedAmount: number
	invitedReferrals: Friend[]
};

const FriendsPage: React.FC = () => {
  const { telegramData, loginData } = useAppContext();
  const [invitedBy, setInvitedBy] = useState<number>(0)
  const [friends, setFriends] = useState<Friend[]>([]);
  const [friendData, setFriendData] = useState<FriendData>();
  const [invitationLink, setInvitationLink] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFriends = async () => {
      if (!telegramData) return
      try {
        if (telegramData.user.id) {
          // Fetch friends from your API using TelegramData
          const response = await axios.get<FriendData>(`${telegramData.settings.apiHost}/referral/${telegramData.user.id}`);
          if (response.data) {
            setFriendData(response.data)
            setFriends(response.data.invitedReferrals);
            setInvitedBy(response.data.invitedByTG)
          } else {
            console.error('Expected an array but got:', response.data);
            setFriends([]); // Set to empty array if not an array
          }
        }
      } catch (error) {
          console.error('Error fetching tasks:', error);
          setFriends([]); 
      } finally {
          setLoading(false);
          setInvitationLink(`https://t.me/notappgame_bot/?start=${telegramData.user.id}`);
      }
    };

    fetchFriends();
  }, [telegramData]);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(invitationLink);
  };

  return (loginData == null ? ( <>
    </> 
  ) : (
    <div className="flex flex-col gap-2 p-8 h-full">
      {/* Initial Box with Text */}
      <p className='italic mb-4 text-gray-600'>Invite friends and increase your FM Limit by x0.1 for each NOTACTIVE friend!</p>

      {/* Friends Header */}
      <div className='flex flex-col gap-2'>
        <h2 className="page-header">Friends</h2>
        <hr className="page-hr" />
      </div>

      {loading ? 
        <div className='flex-1 flex items-center justify-center'>
          <p className='page-header italic text-gray-600'>Loading...</p>
        </div> : 
        <div className='flex flex-col gap-4'>
        {/* Invitation Link Section */} 
        <div className='flex flex-col gap-2'>
          <h3 className="text-lg font-semibold">Invitation Link:</h3>
          <div className="flex gap-2 justify-between">
            <span onClick={copyToClipboard} className="text-lg underline">{invitationLink}</span>
            <button
              onClick={copyToClipboard}
              className="px-2"
            >
              Copy
            </button>
          </div>
        </div>

        {/* Invited By Section */}
        <div className="flex gap-4 items-end">
          <h3 className="text-lg font-semibold">Invited By:</h3>
          {/*<p>{friendData?.invitedByTG || 'Noone'}</p>*/}
          <p className="text-gray-600 text-lg">
            {friendData?.invitedByTGLogin ? (
              <a
                href={`https://t.me/${friendData.invitedByTGLogin}`}
                target="_blank"
                rel="noopener noreferrer"
                className='hover:underline cursor-pointer'
              >
                @{friendData.invitedByTGLogin}
              </a>
            ) : invitedBy ? (
              <span>ID {invitedBy} TG User</span>
            ) : (
              <span>Noone</span>
            )}
          </p>
        </div>

        {/* Friends List */}
        <div className="flex flex-col">
          <h3 className="text-lg font-semibold">
            {`You Invited ${friends?.length || 0} Friend${friends?.length >= 2 ? 's' : ''}:`}
          </h3>
          {friends ? (
            friends.length > 0 ? (
              friends.map((friend) => (
                <FriendUnit key={friend.tgID} friend={friend} />
              ))
            ) : (
              <p>No invited friends yet.</p>
            )
          ) : (
            <p>You have not invited anyone. Use the invitation link above.</p>
          )}
        </div>
      </div>}
    </div> 
    )
  );
};

export default FriendsPage;
